import {
	Box,
	Flex,
	IconButton,
	Spinner,
	useDisclosure,
} from "@chakra-ui/react";
import { FiPlusCircle } from "react-icons/fi";
import { ConversationCard } from "./ConversationCard";
import { ConversationListProps } from "../types/SharedProps.types";
import Tooltip from "components/Tooltip";
import { CreateConversationModal } from "../CreateConversationModal";
import { ProcuraconContextType } from "newui/types/ContextType.type";

/**
 * Provides a list view of all conversations
 * @param param0
 * @returns
 */
export const ConversationList: React.FC<ConversationListProps> = ({
	canCreateConversation,
	additionalContextId,
	contextId,
	contextType,
	isLoading,
	selectedConversation,
	conversations,
	onConversationSelected,
	onConversationCreated,
}) => {
	const { isOpen, onOpen, onClose } = useDisclosure();

	return (
		<Box
			w={{ base: "100%" }}
			className="border-r bg-white"
		>
			<Box
				p={3}
				className="border-b"
			>
				<Flex
					gap={2}
					align="center"
				>
					Select a Conversation below to view messages
					{/* <Input
						placeholder="Search messages"
						size="sm"
					/>
					<IconButton
						aria-label="search"
						icon={<FiSearch />}
						size="sm"
					/> */}
				</Flex>
			</Box>
			{canCreateConversation && contextId && contextType && (
				<Box
					p={1}
					className="border-b hover:bg-blue-100"
				>
					<Tooltip label="Create a new conversation">
						<Flex
							gap={2}
							align={"center"}
							className="cursor-pointer"
							onClick={onOpen}
						>
							<IconButton
								aria-label=""
								icon={<FiPlusCircle size={30} />}
							/>
							<div>Create New RFI</div>
						</Flex>
					</Tooltip>
				</Box>
			)}

			{isLoading ? (
				<Flex
					justify="center"
					p={6}
				>
					<Spinner />
				</Flex>
			) : (
				<Box
					overflowY="auto"
					h="calc(100% - 56px)"
				>
					{conversations?.map((conv) => (
						<ConversationCard
							key={conv.id}
							conversation={conv}
							active={selectedConversation?.id === conv.id}
							onClick={() => onConversationSelected(conv)}
						/>
					))}
				</Box>
			)}
			<CreateConversationModal
				additionalContextId={additionalContextId}
				contextId={contextId}
				contextType={ProcuraconContextType.RFX_PRE_SUBMISSION}
				isOpen={isOpen}
				onClose={onClose}
				onConversationCreated={onConversationCreated}
			/>
		</Box>
	);
};
